module.exports = __webpack_public_path__ + "static/media/knex.47ebdbaf.png";